import type { XMPPClient, XMPPCredentials, XMPPCredentialsAuth, XMPPOptions, XMPPUserAgent } from '@xmppClient';
import type { FAST } from '@xmpp/client-core/src/fast/fast.js';

export function createOnAuthenticate(credentials: XMPPCredentials = {}, userAgent: XMPPUserAgent) {
  return async function onAuthenticate(...args: unknown[]) {
    const [authenticate, mechanisms, fast, entity] = args as [XMPPCredentialsAuth, string[], FAST, XMPPClient];

    if (typeof credentials === 'function') {
      const mechanism = getMechanism(mechanisms, entity);

      await credentials(authenticate, mechanism);
    } else {
      credentials.token ??= await fast?.fetch();

      const mechanism = getMechanism(mechanisms, entity, credentials);

      await authenticate(credentials, mechanism, userAgent);
    }
  };
}

export function getMechanism(mechanisms: string[], entity: XMPPClient, options?: XMPPOptions): string {
  const username = options?.username || entity.options?.username;
  const password = options?.password || entity.options?.password;
  const token = options?.token || entity.options?.token;

  if (!username && !password && !token && mechanisms.includes('ANONYMOUS')) {
    return 'ANONYMOUS';
  }

  if (entity.isSecure() || entity.tcpEnabled) return mechanisms[0];

  return mechanisms.find((mechanism) => mechanism !== 'PLAIN') ?? '';
}

export function getDomain(service: string): string {
  const domain = service.split('://')[1] || service;

  return domain.split(':')[0].split('/')[0];
}

export function setupIfAvailable(module?: (...args: any[]) => any, ...args: unknown[]): unknown {
  if (typeof module !== 'function') {
    return undefined;
  }

  return module(...args);
}
